import React from 'react';
import Icon from "../";
export default function IconUserAltCircle(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<circle cx=\"12\" cy=\"12\" r=\"9.5\" fill=\"none\" stroke=\"#181818\"/><path d=\"M18 19.21v-.37a3.9 3.9 0 00-.46-2.07 3.53 3.53 0 00-1.32-1.3L14 14.19a.74.74 0 01-.23-1.19l.37-.39.09-.09a4 4 0 001.29-2.87A3.72 3.72 0 0012 5.79a3.72 3.72 0 00-3.53 3.89 4 4 0 001.29 2.87l.09.09.37.39a.74.74 0 01-.22 1.16l-2.22 1.27a3.53 3.53 0 00-1.32 1.3A3.9 3.9 0 006 18.83v.37\" fill=\"none\" stroke=\"#181818\"/>"
    }
  }));
}